import React from "react"
import PDF from "@/public/icons/PDF-ANN.svg"
import Download from "@/public/icons/download-dark-gray.svg"
import { addDataLayer } from "../ProductDetailView/analytics"
const TabDetails = props => {
  const { detailsData, productBrandName, productInfo } = props
  return (
    <div className="content-row">
      <div className="col-text">
        <p>{detailsData?.description}</p>
      </div>
    {detailsData?.tearSheet && 
      <div className="col-pdf pdfList">
        <div className="files">
          <a
            title={productBrandName}
            href={detailsData?.tearSheet}
            target="_blank"
            className="uploadFile"
            rel="noreferrer"
            onClick={() => {
              addDataLayer({
                title: "file download",
                url: detailsData?.tearSheet?.[0],
                isDetailsTab: true,
                productInfo,
                eventStatus: "success",
                pdfProps: {
                  isPdf: true,
                  fileName: `${productBrandName.toLowerCase()}`,
                  pdf_Data: JSON.stringify({
                    fileNameAndFileType: `${
                      productBrandName.toLowerCase() + ".pdf"
                    }`,
                  }),
                },
              })
            }}
          >
            <span className="pdfWrapper">
              <img src={PDF?.src} />
              <span>{productBrandName}</span>
            </span>
            <img src={Download?.src} />
          </a>
        </div>
      </div>
    }
    </div>
  )
}

export default TabDetails
